export default {
  common: {
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    search: 'Search',
    loading: 'Loading...',
    noData: 'No data available.',
    confirm: 'Confirm',
    close: 'Close',
    more: 'More',
  },

  header: {
    allProducts: 'All Products',
    best: 'Best',
    newArrival: 'New Arrivals',
    cart: 'Cart',
    mypage: 'My Page',
    admin: 'Admin',
    login: 'Login',
    register: 'Sign Up',
    logout: 'Logout',
    products: 'Products',
    groupBuys: 'Limited Drops',
    proxyBuy: 'Item Request',
    faq: 'How It Works',
    support: 'Support',
    event: 'Event',
  },

  home: {
    heroTitle: 'A Special Choice\nfor Your Beauty',
    heroSub: 'Find your perfect beauty routine at our specialty store',
    searchPlaceholder: 'Search by product name or brand',
    category: 'Categories',
    bestProducts: '🏆 Best Sellers',
    newProducts: '✨ New Arrivals',
    noProducts: 'No products available.',
  },

  categories: {
    skincare: 'Skincare',
    makeup: 'Makeup',
    suncare: 'Sun Care',
    haircare: 'Hair Care',
    bodycare: 'Body Care',
    perfume: 'Perfume',
    mensBeauty: "Men's Beauty",
    beautyTools: 'Beauty Tools',
  },

  product: {
    brand: 'Brand',
    price: 'Price',
    salePrice: 'Sale Price',
    discount: '% OFF',
    stock: 'Stock',
    inStock: ' left',
    outOfStock: 'Sold Out',
    variant: 'Design',
    selectVariant: 'Please select a design',
    quantity: 'Qty',
    total: 'Total',
    addToCart: '🛒 Add to Cart',
    buyNow: 'Buy Now',
    detail: 'Product Detail',
    reviews: 'Reviews',
    noDescription: 'No description available.',
    noReviews: 'No reviews yet.',
    addingCart: 'Adding...',
    cartAdded: 'Added to cart!',
    cartAddFailed: 'Could not add to cart. Please try again.',
    reviewCount: '{{count}} Reviews',
    viewCount: '{{count}} Views',
  },

  productList: {
    all: 'All',
    latest: 'Latest',
    best: 'Best Sellers',
    newArrival: 'New Arrivals',
    sort: 'Sort',
    itemCount: ' products',
    noResults: '🔍 No results found.',
    searchResults: 'Search Results',
  },

  cart: {
    title: 'Shopping Cart',
    empty: 'Your cart is empty.',
    goShopping: 'Go Shopping',
    subtotal: 'Subtotal',
    shipping: 'Shipping',
    freeShipping: 'Free',
    totalWeight: 'Total weight',
    selectAll: 'Select all',
    calcAtCheckout: 'Calculated at checkout',
    total: 'Total',
    checkout: 'Checkout',
    freeShippingGuide: '✅ Free shipping applied!',
    freeShippingRemain: ' more for free shipping',
    loginRequired: 'Please log in.',
    goLogin: 'Go to login',
  },

  order: {
    title: 'Order & Payment',
    delivery: 'Delivery Info',
    receiverName: 'Recipient',
    receiverPhone: 'Phone',
    zipCode: 'Zip Code',
    address: 'Address',
    addressDetail: 'Address Detail',
    memo: 'Delivery Note',
    memoPlaceholder: 'Special delivery instructions',
    payment: 'Payment Method',
    coupon: 'Coupon',
    couponPlaceholder: 'Enter coupon code',
    orderProducts: 'Order Items',
    pay: ' Pay Now',
    processing: 'Processing...',
    success: 'Order placed successfully!',
    failed: 'Order failed',
    methods: {
      CARD: 'Credit / Debit Card',
      STRIPE: 'Credit Card (Stripe)',
      BANK_TRANSFER: 'Bank Transfer',
      KAKAO_PAY: 'Kakao Pay',
      NAVER_PAY: 'Naver Pay',
      PAYPAL: 'PayPal',
    },
    paypalInfo: 'Click the PayPal button to open the payment window.',
    stripeAmount: 'Stripe Charge',
    stripeLoading: 'Loading payment info...',
    fillRequired: 'Please fill in all required delivery fields.',
  },

  auth: {
    loginTitle: 'Login',
    loginSub: 'Welcome to Moa',
    registerTitle: 'Sign Up',
    registerSub: 'Join Moa and enjoy exclusive benefits',
    email: 'Email',
    emailPlaceholder: 'Enter your email',
    password: 'Password',
    passwordPlaceholder: 'Enter your password',
    passwordHint: 'At least 8 characters',
    name: 'Name',
    namePlaceholder: 'Your name',
    phone: 'Phone',
    phonePlaceholder: '(555) 000-0000',
    loginBtn: 'Login',
    registerBtn: 'Sign Up',
    loggingIn: 'Logging in...',
    processing: 'Processing...',
    sendCode: 'Send code',
    sendingCode: 'Sending...',
    resendCode: 'Resend',
    codeSent: 'Verification code sent. Please check your email (valid for 5 min).',
    codeSendFailed: 'Failed to send code',
    emailRequired: 'Please enter your email first',
    verifyCode: 'Verification code',
    verifyCodePlaceholder: '6-digit code',
    noAccount: "Don't have an account?",
    hasAccount: 'Already have an account?',
    goRegister: 'Sign Up',
    goLogin: 'Login',
  },

  mypage: {
    title: 'Order History',
    noOrders: 'No orders found.',
    goShopping: 'Go Shopping',
    orderNumber: 'Order #',
    viewDetail: 'View Detail',
    orderTotal: 'Total',
  },

  orderDetail: {
    title: 'Order Detail',
    backToList: '← Back to Orders',
    orderProducts: 'Items',
    delivery: 'Shipping',
    payment: 'Payment',
    receiverName: 'Recipient',
    receiverPhone: 'Phone',
    address: 'Address',
    memo: 'Delivery Note',
    paymentMethod: 'Method',
    productAmount: 'Subtotal',
    shipping: 'Shipping',
    couponDiscount: 'Coupon Discount',
    finalAmount: 'Total',
    notFound: 'Order not found.',
    tracking: 'Tracking',
    trackingNumber: 'Tracking #',
    courier: 'Carrier',
    trackingView: 'View tracking',
    trackingEmpty: 'No tracking updates yet.',
    trackingClose: 'Close',
    trackingUspsHint: 'Inside the US, you can also track this number on USPS.',
    trackingUspsLink: 'Track on USPS',
    packingVideo: 'Packing video',
    packingVideoView: 'Watch video',
    cancelBtn: 'Cancel Order',
    cancelTitle: 'Cancel this order?',
    cancelReason: 'Reason (optional)',
    cancelReasonPlaceholder: 'Why are you cancelling?',
    cancelConfirm: 'Cancel Order',
    cancelSuccess: 'Order cancelled.',
    cancelFailed: 'Failed to cancel order.',
    cancelledAt: 'Cancelled at',
    cancelReasonLabel: 'Cancel reason',
    refundBtn: 'Request Refund',
    refundTitle: 'Request a refund?',
    refundReason: 'Refund reason',
    refundReasonPlaceholder: 'Tell us why (required)',
    refundConfirm: 'Submit Request',
    refundSuccess: 'Refund request submitted.',
    refundFailed: 'Failed to submit refund request.',
    refundRequestedAt: 'Requested at',
    refundReasonLabel: 'Refund reason',
  },

  review: {
    write: 'Write a Review',
    writeTitle: 'Share your thoughts',
    ratingLabel: 'Rating',
    contentLabel: 'Review',
    contentPlaceholder: 'Share your honest opinion about this product. (at least 10 characters)',
    submit: 'Post',
    submitting: 'Posting...',
    success: 'Your review has been posted.',
    duplicate: 'You have already reviewed this product.',
    deleteConfirm: 'Delete this review?',
    deleted: 'Review deleted.',
    loginRequired: 'Please log in to write a review.',
    contentMin: 'Review must be at least 10 characters.',
  },

  orderStatus: {
    PENDING: 'Pending Payment',
    PAID: 'Paid',
    PREPARING: 'Preparing',
    SHIPPING: 'Shipping',
    DELIVERED: 'Delivered',
    CANCELLED: 'Cancelled',
    REFUND_REQUESTED: 'Refund Requested',
    REFUNDED: 'Refunded',
  },

  cartRecommend: {
    youMightLike: 'You Might Also Like',
    customersBought: 'Customers Also Bought',
  },

  floatingCart: {
    title: 'Cart',
    empty: 'Your cart is empty',
    total: 'Total',
    checkout: 'Checkout',
    viewCart: 'View Cart',
  },

  events: {
    title: 'Events',
    noEvents: 'No events available.',
    shopNow: 'Shop Now',
    products: ' products',
    endsAt: 'Ends',
    backToEvents: 'Back to Events',
    noProducts: 'No products in this event.',
    notFound: 'Event not found.',
  },

  sale: {
    title: 'On Sale',
    badge: '% OFF',
  },

  footer: {
    cs: 'Customer Service',
    csHours: 'Mon–Fri 09:00–18:00',
    rights: '© 2026 Moa. All rights reserved.',
    partnership: 'Partnership Inquiry',
    privacy: 'Privacy Policy',
    terms: 'Terms of Service',
    contentSoon: 'Content coming soon.',
  },
};
